// Close the cart drawer when the checkout button is clicked
document.addEventListener("click", function (event) {
  const checkoutBtn = event.target.closest(
    'button[name="checkout"], a[name="checkout"], .cart__checkout-button'
  );
  if (!checkoutBtn) return;

  const closeBtn = document.querySelector(
    ".cart-drawer__dialog .cart-drawer__close-button"
  );

  if (closeBtn) {
    closeBtn.click();
  }
}, true);

// Close the cart drawer when the backdrop is clicked
(function () {
  document.addEventListener("click", function (event) {
    const dialog = document.querySelector(".cart-drawer__dialog");
    if (!dialog) return;

    // When clicking backdrop, event.target is the <dialog> itself
    if (event.target === dialog) {
      const closeBtn = dialog.querySelector(".cart-drawer__close-button");
      if (closeBtn) {
        // Prevent auto-open loop
        window.__suppressCartAutoOpen = true;
        setTimeout(() => { window.__suppressCartAutoOpen = false; }, 800);
        closeBtn.click();
      }
    }
  }, true);
})();

// Hide the default section title on collection pages that use the custom banner
document.addEventListener('DOMContentLoaded', function () {
  const banner = document.querySelector('.collection-hero');
  const defaultTitle = document.querySelector('.custom-section-content');

  if (banner && defaultTitle) {
    defaultTitle.style.display = 'none';
  }
});
